<div fxFill>
    <div fxLayoutAlign="center center">
        <mat-card style="margin-top: 125px" fxFlex.xs="90" fxFlex.sm="75" fxFlex.gt-sm="50">
            <mat-card-content>
                <div fxLayout="row" fxLayoutAlign="center" style="margin-top: 10px">
                    <button (click)="signInGoogle()" mat-raised-button color="primary" aria-label="login" fxFlex>
                        <span>Google login</span>
                    </button>
                </div>
            </mat-card-content>
        </mat-card>
    </div>
</div>
